import { Component, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectInputComponent } from '../../../kit/input/select-input/select-input.component';
import { OrganizationSettingsMadoTransactionsStore } from './organization-settings-mado-transactions.store';
import { madoAccountToDropdownOptionString } from 'packages/client/src/app/utils/mado/account.utils';

@Component({
    selector: 'app-organization-settings-mado-transactions',
    templateUrl: 'organization-settings-mado-transactions.component.html',
    imports: [
        SelectInputComponent,
    ],
    providers: [OrganizationSettingsMadoTransactionsStore]
})
export class OrganizationSettingsMadoTransactionsComponent {
    public form = input<FormGroup>();
    
    protected readonly store = inject(OrganizationSettingsMadoTransactionsStore);
    
    protected readonly translatePrefix = 'organization-settings.madoSettings.';
    protected readonly madoAccountToDropdownOptionString = madoAccountToDropdownOptionString
}
